export default __webpack_public_path__ + "static/media/Bloco_Lemy_Ayò-Bloco_Afro_FEBARJ.0a3e1420.jpg";